class PostcodeValidator extends HTMLElement {
  constructor() {
    super();
    this.validPostcodes = window.VALID_POSTCODES || [];
    this.input = null;
    this.checkoutButtons = [];
  }

  connectedCallback() {
    this.input = this.querySelector('input[name="postcode"]');
    this.messageElement = this.querySelector('.postcode-validator__message');

    if (this.input) {
      this.input.addEventListener('input', this.debounce(() => this.validatePostcode(), 500));
      this.input.addEventListener('blur', () => this.validatePostcode());
    }

    // Find checkout buttons in the same form/section
    const container = this.closest('form') || this.closest('.cart__footer') || this.closest('.drawer__footer');
    if (container) {
      this.checkoutButtons = Array.from(container.querySelectorAll('button[name="checkout"], button#checkout, button#CartDrawer-Checkout'));
    }

    // Check if there's a saved postcode
    const savedPostcode = localStorage.getItem('deliveryPostcode');
    if (savedPostcode && this.input) {
      this.input.value = savedPostcode;
      this.validatePostcode();
    } else if (!savedPostcode) {
      // Show initial message if no saved postcode
      this.showMessage('Please enter your postcode to continue', 'error');
      this.disableCheckout();
    }
  }

  validatePostcode() {
    if (!this.input) return;

    const postcode = this.input.value.trim();

    if (!postcode) {
      this.showMessage('Please enter your postcode to continue', 'error');
      this.disableCheckout();
      localStorage.removeItem('deliveryPostcode');
      return;
    }

    if (this.validPostcodes.length === 0) {
      this.showMessage('Loading postcodes...', 'loading');
      this.disableCheckout();
      return;
    }

    const isValid = this.validPostcodes.includes(postcode);

    if (isValid) {
      this.showMessage('Delivery available to your postcode', 'success');
      this.enableCheckout();
      localStorage.setItem('deliveryPostcode', postcode);
    } else {
      this.showMessage('Sorry, we don\'t currently deliver to this postcode', 'error');
      this.disableCheckout();
      localStorage.removeItem('deliveryPostcode');
    }
  }

  showMessage(text, type) {
    if (!this.messageElement) return;

    this.messageElement.textContent = text;
    this.messageElement.className = `postcode-validator__message postcode-validator__message--${type}`;
    this.messageElement.style.display = 'block';
  }

  disableCheckout() {
    this.checkoutButtons.forEach(button => {
      button.disabled = true;
      button.classList.add('disabled');
    });
  }

  enableCheckout() {
    this.checkoutButtons.forEach(button => {
      // Only enable if cart is not empty
      const cartEmpty = button.hasAttribute('data-cart-empty') ||
                       document.querySelector('.cart')?.classList.contains('is-empty');
      if (!cartEmpty) {
        button.disabled = false;
        button.classList.remove('disabled');
      }
    });
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

customElements.define('postcode-validator', PostcodeValidator);
